export default __webpack_public_path__ + "static/media/Capitals.eb08035b.png";